import CompanyCmdTab from 'src/components/pages/Company/CompanyPage/CompanyCmdTab/CompanyCmdTab';

export default CompanyCmdTab;
